import { render } from "./ElementItemGroup.vue?vue&type=template&id=5a894c22"
import script from "./ElementItemGroup.vue?vue&type=script&lang=js"
export * from "./ElementItemGroup.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/OpenMCT/OpenMCT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__